/* BATKOS theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var B = window.Batkos || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || B.moneyFormat || '{{amount_with_comma_separator}} TL';
    function delimit(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      var num = (n / 100).toFixed(prec);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
      return parts[1] ? whole + dec + parts[1] : whole;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    switch (key) {
      case 'amount': val = delimit(cents, 2); break;
      case 'amount_no_decimals': val = delimit(cents, 0); break;
      case 'amount_with_comma_separator': val = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delimit(cents, 2, "'", '.'); break;
      case 'amount_with_period_and_space_separator': val = delimit(cents, 2, ' ', '.'); break;
      default: val = delimit(cents, 2);
    }
    // drop trailing zero decimals (890,00 TL -> 890 TL)
    val = val.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  B.formatMoney = formatMoney;

  /* ---------- drawers ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-drawer="' + name + '"]'); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = $('[data-close]:not(.scrim)', d); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer(d) {
    d.classList.remove('open'); d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-open-menu]')) { e.preventDefault(); openDrawer('menu'); return; }
    if (t.closest('[data-open-cart]') && $('[data-drawer="cart"]')) { e.preventDefault(); refreshCart().then(function () { openDrawer('cart'); }); return; }
    var c = t.closest('[data-close]'); if (c) { closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.drawer.open').forEach(closeDrawer);
  });

  /* ---------- cart ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('on', cart.item_count > 0); });
    var box = $('[data-cart-items]'); if (!box) return cart;
    if (!cart.items.length) { box.innerHTML = '<p class="cd-empty">Sepetin şimdilik boş.</p>'; }
    else {
      box.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        var disc = (it.original_line_price > it.final_line_price)
          ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        return '<div class="cd-item">' +
          (img ? '<img src="' + img + '" alt="" width="72" height="72">' : '<span></span>') +
          '<div class="cd-i"><b>' + esc(it.product_title) + '</b>' +
          (it.variant_title ? '<small>' + esc(it.variant_title) + '</small>' : '') +
          '<div class="qty" data-line="' + (i + 1) + '">' +
          '<button type="button" data-q="-1" aria-label="Azalt">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Arttır">+</button></div></div>' +
          '<div class="cd-p">' + disc + '<b>' + formatMoney(it.final_line_price) + '</b></div></div>';
      }).join('');
    }
    var tot = $('[data-cart-total]'); if (tot) tot.textContent = formatMoney(cart.total_price);
    /* merchant-only check: theme editor or unpublished preview, never shown to shoppers */
    var warn = $('[data-discount-warn]');
    if (warn) {
      var role = window.Shopify && Shopify.theme && Shopify.theme.role;
      var merchantView = B.designMode || (role && role !== 'main');
      var discount = (cart.total_discount || 0) + cart.items.reduce(function (a, it) { return a + Math.max(0, (it.original_line_price || 0) - (it.final_line_price || 0)); }, 0);
      var needsFree = cart.items.some(function (it) { return it.quantity >= 2; });
      warn.hidden = !(merchantView && needsFree && discount === 0);
    }
    return cart;
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cd-item [data-q]'); if (!b) return;
    var wrap = b.closest('[data-line]'); var line = +wrap.getAttribute('data-line');
    var q = Math.max(0, +$('span', wrap).textContent + (+b.getAttribute('data-q')));
    fetch((B.routes && B.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: q })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------- product ---------- */
  $$('[data-product]').forEach(function (root) {
    var unit = parseInt(root.getAttribute('data-unit'), 10) || 0;
    var form = $('[data-product-form]', root) || $('form[action*="/cart/add"]', root);
    var qtyInput = $('[data-qty-input]', root);
    var idInput = $('[data-variant-id]', root);
    var sticky = $('[data-sticky]');
    var opts = $$('.opt', root);

    function currentQty() {
      var c = $('.opt input:checked', root);
      return c ? +c.closest('.opt').getAttribute('data-qty') : (qtyInput ? +qtyInput.value : 1);
    }
    function paidQty() {
      var c = $('.opt input:checked', root);
      return c ? +c.closest('.opt').getAttribute('data-paid') : currentQty();
    }
    function sync() {
      var q = currentQty(), pay = unit * paidQty();
      if (qtyInput) qtyInput.value = q;
      var set = function (sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); };
      set('[data-sum-label]', 'Seçili paket: ' + q + ' kavanoz');
      set('[data-sum-price]', formatMoney(pay));
      set('[data-pack]', 'Paket içeriği: ' + q + ' × 150 ML');
      set('[data-total-ml]', 'Toplam ' + (q * 150) + ' ML');
      set('[data-sticky-sum]', q + ' kavanoz · ' + formatMoney(pay));
    }
    function repriceTiers() {
      opts.forEach(function (o) {
        var p = +o.getAttribute('data-paid'), f = +o.getAttribute('data-free'), q = p + f;
        var pay = unit * p, full = unit * q;
        var s = function (sel, t) { var el = $(sel, o); if (el) el.textContent = t; };
        s('[data-pay]', formatMoney(pay)); s('[data-full]', formatMoney(full));
        s('[data-per]', formatMoney(Math.round(pay / q)) + ' / adet');
        s('[data-save]', formatMoney(full - pay) + ' kazanç');
      });
    }
    opts.forEach(function (o) { $('input', o).addEventListener('change', sync); });
    var vs = $('[data-variant-select]', root);
    if (vs) vs.addEventListener('change', function () {
      var opt = vs.options[vs.selectedIndex];
      unit = parseInt(opt.getAttribute('data-price'), 10) || unit;
      if (idInput) idInput.value = vs.value;
      repriceTiers(); sync();
    });
    sync();

    /* AJAX add to cart → cart drawer */
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = $('[data-atc]', form); var label = $('[data-atc-label]', form);
      var old = label ? label.textContent : '';
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +idInput.value, quantity: +qtyInput.value }] })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () {
          if (btn) btn.classList.add('added'); if (label) label.textContent = 'Sepete eklendi';
          return refreshCart();
        })
        .then(function () { if ($('[data-drawer="cart"]')) openDrawer('cart'); else location.href = '/cart'; })
        .catch(function () { form.submit(); })
        .then(function () {
          setTimeout(function () { if (btn) { btn.classList.remove('added'); btn.removeAttribute('aria-busy'); } if (label) label.textContent = old; }, 1800);
        });
    });

    /* sticky bar */
    var mainBtn = $('[data-atc]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('on', past); sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        var sb = $('[data-sticky-btn]', sticky); if (sb) sb.tabIndex = past ? 0 : -1;
      });
      io.observe(mainBtn);
      $('[data-sticky-btn]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else mainBtn.click();
      });
    }

    /* gallery (photos + videos, up to 16) */
    var track = $('[data-track]', root);
    if (track) {
      var gal = track.closest('[data-gallery]');
      var thumbs = $$('[data-thumb]', gal), slides = $$('figure', track);
      var idxEl = $('[data-g-index]', gal), cur = -1;
      var go = function (i) { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
      var setActive = function (i) {
        if (i === cur) return; cur = i;
        thumbs.forEach(function (t, k) { t.classList.toggle('on', k === i); });
        var on = thumbs[i];
        if (on && on.parentNode.scrollWidth > on.parentNode.clientWidth) {
          on.parentNode.scrollTo({ left: on.offsetLeft - on.parentNode.clientWidth / 2 + on.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
        if (idxEl) idxEl.textContent = i + 1;
        slides.forEach(function (f, k) {
          var v = $('video', f); if (!v) return;
          if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
        // stop embedded players that scrolled away
        slides.forEach(function (f, k) {
          var fr = $('iframe', f); if (!fr || k === i) return;
          try { fr.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'); fr.contentWindow.postMessage('{"method":"pause"}', '*'); } catch (e) {}
        });
      };
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-thumb')); }); });
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () { tick = null; setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (e.key === 'ArrowRight') go(Math.min(i + 1, slides.length - 1));
        if (e.key === 'ArrowLeft') go(Math.max(i - 1, 0));
      });
      $$('[data-sound]', track).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = $('video', b.closest('figure')); if (!v) return;
          v.muted = !v.muted; if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          b.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
          b.setAttribute('aria-label', v.muted ? 'Sesi aç' : 'Sesi kapat');
        });
      });
      // only autoplay while the gallery is on screen
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          slides.forEach(function (f, k) { var v = $('video', f); if (!v) return; if (en[0].isIntersecting && k === cur) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: .4 }).observe(track);
      }
      setActive(0);
    }
  });

  /* ---------- honey glow ---------- */
  $$('[data-honey]').forEach(function (el) {
    var fine = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    var raf = null, auto = null, autoT0 = 0, lastPointer = 0;
    function place(x, y) {
      el.style.setProperty('--mx', x + 'px'); el.style.setProperty('--my', y + 'px');
    }
    function radius() { el.style.setProperty('--r', Math.max(120, Math.min(260, el.clientWidth * .2)) + 'px'); }
    radius(); window.addEventListener('resize', radius);
    function onMove(e) {
      lastPointer = Date.now();
      var r = el.getBoundingClientRect();
      var x = e.clientX - r.left, y = e.clientY - r.top;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { place(x, y); el.classList.add('lit'); });
    }
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerdown', onMove);
    el.addEventListener('pointerleave', function () { if (fine) el.classList.remove('lit'); });

    /* touch / no-hover: slow honey sweep while visible */
    if (!fine && !reduce && 'IntersectionObserver' in window) {
      var hx = parseFloat(getComputedStyle(el).getPropertyValue('--hx')) || 50;
      var hy = parseFloat(getComputedStyle(el).getPropertyValue('--hy')) || 40;
      function loop(t) {
        if (!autoT0) autoT0 = t;
        if (Date.now() - lastPointer > 2500) {
          var k = ((t - autoT0) / 4200) % 1;
          var w = el.clientWidth, h = el.clientHeight;
          var cx = w * hx / 100, cy = h * (hy + 18) / 100;
          place(cx + Math.cos(k * Math.PI * 2) * w * .16, cy + Math.sin(k * Math.PI * 2) * h * .12);
          el.classList.add('lit');
        }
        auto = requestAnimationFrame(loop);
      }
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { if (!auto) auto = requestAnimationFrame(loop); }
        else if (auto) { cancelAnimationFrame(auto); auto = null; autoT0 = 0; }
      }, { threshold: .35 }).observe(el);
    }
  });

  /* ---------- reveal on scroll (only for items starting below the fold) ---------- */
  if ('IntersectionObserver' in window && !reduce) {
    var vh = window.innerHeight;
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.remove('rv-pre'); rio.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.rv').forEach(function (el) {
      if (el.getBoundingClientRect().top > vh) { el.classList.add('rv-pre'); rio.observe(el); }
    });
  }

  /* ---------- hero jar tap ---------- */
  $$('[data-jar]').forEach(function (j) {
    j.addEventListener('touchstart', function () { j.classList.add('tapped'); setTimeout(function () { j.classList.remove('tapped'); }, 700); }, { passive: true });
  });
})();
